import { Routes } from '@angular/router'
import { accountGuard } from './account/account.guard';

const routes: Routes = [
  {path: 'auth', loadChildren: () => import('./auth/auth.routes')},
  {path: 'account', loadChildren: () => import('./account/account.routes'), canActivate: [accountGuard]},
  {path: '**', loadComponent: () => import('./app-redirect.component')},
]

export { routes }
